import React from 'react';

import { GridFilterOperator } from '@mui/x-data-grid';

import { StyledMenuItem, StyledSelect } from 'components/GridFilterStatusSelect/styles';

import { PickerProps } from 'components/Grid/operators/types';

import { BaseStatusOperator } from '../Status/Status';

export type FilterOption = { value: string; label: string };

export type OptionsOperatorSettings = {
  // Opts into "is not". The value is stored with a leading '-'.
  allowIsNot?: boolean;
};

const OptionsPicker =
  (options: FilterOption[]): React.FunctionComponent<PickerProps> =>
  ({ applyValue, item, ...props }) => (
    <StyledSelect
      {...props}
      value={(item.value as string | null) ?? ''}
      fullWidth
      onChange={(event) => applyValue({ ...item, value: event.target.value })}
    >
      {options.map(({ value, label }) => (
        <StyledMenuItem key={value} value={value}>
          {label}
        </StyledMenuItem>
      ))}
    </StyledSelect>
  );

export const OptionsOperator = (
  options: FilterOption[],
  { allowIsNot }: OptionsOperatorSettings = {}
): GridFilterOperator[] => {
  const Picker = OptionsPicker(options);
  return BaseStatusOperator(
    Picker,
    undefined,
    (value) => options.find((option) => option.value === value)?.label ?? value,
    !allowIsNot,
    allowIsNot ? Picker : undefined
  );
};
